import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const oneColumnBannerBackgroundColors = [
  BackgroundColor.MIDNIGHT_BLUE,
  BackgroundColor.PURPLE,
  BackgroundColor.MINT,
  BackgroundColor.MIDNIGHT_FACET,
  BackgroundColor.WHITE_FACET,
  BackgroundColor.FADED_WHITE_FACET,
  BackgroundColor.STONE,
  BackgroundColor.MINT_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT
] as const

export type OneColumnBannerBackgroundColor =
  (typeof oneColumnBannerBackgroundColors)[number]
